import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import Menubar from "../Components/Menubar";
import Totop from "../Components/Totop";
import Footer from "../Components/Footer";
import TeamList from "../Aboutus/Sections/TeamList";
import PAI from "../Aboutus/Sections/PartnersAInvestors";
import { AboutUsModal } from "../Aboutus/AboutUsModal";
import "../Aboutus/Aboutus.css";
import "../IR/IR.css";
import { ThemeContext } from "../../context";

export default function HeringsteamPage() {
  const [open, setOpen] = useState(false);
  const [modalObj, setModalObj] = useState({});
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();

  const handleOpen = (obj) => {
    if (JSON.stringify({}) !== obj) {
      setModalObj(obj);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div
      style={{
        backgroundColor: theme === "dark" && "#282828",
        color: theme === "dark" && "#fff",
      }}
    >
      <Menubar slideIndex={0} />
      <div className="about-main-container">
        <div className="about-section1">
          <div className="ir_text_section1">
            <p className="ir_maintext1">{t("heringsteam.hero.title")}</p>
            <span className="ir_subtext1">
              {t("heringsteam.hero.subtitle").split("\n").map((line, i, arr) => (
                <React.Fragment key={i}>
                  {line}
                  {i < arr.length - 1 && <br />}
                </React.Fragment>
              ))}
            </span>
          </div>
        </div>
        <div className="about-section2">
          <div id="heringsteam">
            <TeamList handleOpen={handleOpen} />
          </div>
          <div id="researchpartners">
            <PAI />
          </div>
        </div>
        <Totop />
        <Footer />
      </div>
      <AboutUsModal open={open} handleClose={handleClose} modalObj={modalObj} />
    </div>
  );
}
